module.exports = __webpack_public_path__ + "images/help/icon-twr43@2x-7d18673d8b601d0c0b03eb6f2516aed8.png";